/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Drop_Frame_FalseInputs */

const en_dialogue_list_export_drop_frame_false = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`false`)
};

const fr_dialogue_list_export_drop_frame_false = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`faux`)
};

const de_dialogue_list_export_drop_frame_false = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FALSCH`)
};

const it_dialogue_list_export_drop_frame_false = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`falso`)
};

const ru_dialogue_list_export_drop_frame_false = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЛОЖЬ`)
};

const es_dialogue_list_export_drop_frame_false = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FALSO`)
};

const zh_cn2_dialogue_list_export_drop_frame_false = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误的`)
};

const ja_dialogue_list_export_drop_frame_false = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間違い`)
};

const hi_dialogue_list_export_drop_frame_false = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असत्य`)
};

const pt_pt2_dialogue_list_export_drop_frame_false = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_FalseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`falso`)
};

/**
* | output |
* | --- |
* | "false" |
*
* @param {Dialogue_List_Export_Drop_Frame_FalseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_drop_frame_false = /** @type {((inputs?: Dialogue_List_Export_Drop_Frame_FalseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Drop_Frame_FalseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_drop_frame_false(inputs)
	if (locale === "de") return de_dialogue_list_export_drop_frame_false(inputs)
	if (locale === "it") return it_dialogue_list_export_drop_frame_false(inputs)
	if (locale === "ru") return ru_dialogue_list_export_drop_frame_false(inputs)
	if (locale === "es") return es_dialogue_list_export_drop_frame_false(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_drop_frame_false(inputs)
	if (locale === "ja") return ja_dialogue_list_export_drop_frame_false(inputs)
	if (locale === "hi") return hi_dialogue_list_export_drop_frame_false(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_drop_frame_false(inputs)
	return en_dialogue_list_export_drop_frame_false(inputs)
});